<template>
  <el-form v-loading="loading" ref="ff" :model="detail" label-position="top">
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="询价标题" prop="Title" required>
          <el-input v-model="detail.Title" />
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="类别" prop="Mode" required>
          <itemPicker :current.sync="detail.Mode" typeId="inquiry-mode" />
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="询价编号">
          <el-input v-model="detail.Code" placeholder="如果不填，系统将自动创建" :disabled="detail.Code" />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="询价单位" prop="Customer" required>
          <el-input v-model="detail.Customer" />
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="询价时间" class="flexItem">
          <el-date-picker v-model="detail.BeginDate" type="datetime" value-format="yyyy-MM-dd HH:mm" placeholder="开始时间" />
          <span style="margin: 0 10px">至</span>
          <el-date-picker v-model="detail.ExpiryDate" type="datetime" value-format="yyyy-MM-dd HH:mm" placeholder="截止时间" />
        </el-form-item>
      </el-col>
      <el-col :span="4">
        <el-form-item label="控制总价" prop="BudgetPrice" required>
          <el-input v-model="detail.BudgetPrice">
            <span style="padding: 0 5px" slot="prefix">￥</span>
          </el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="送货地址">
          <el-input v-model="detail.Address" />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="联系人" class="flexItem" required>
          <el-input v-model="detail.Linkman" placeholder="姓名" />
          <el-input v-model="detail.Linktel" placeholder="电话" />
        </el-form-item>
      </el-col>
      <el-col>
        <el-form-item label="询价目录">
          <el-input type="textarea" rows="4" v-model="detail.Columns" />
        </el-form-item>
      </el-col>
      <el-col>
        <el-form-item label="商务要求">
          <el-input type="textarea" rows="4" v-model="detail.Demands" />
        </el-form-item>
      </el-col>
    </el-row>
    <el-form-item>
      <el-button type="primary" @click="onSubmit">提交/保存</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
export default {
  components: {
    itemPicker: () => import("@/views/system/meta/item/picker.vue")
  },
  data () {
    return {
      loading: false,
      detail: {}
    }
  },
  props: {
    id: { type: String, default: null }
  },
  created () {
    if (this.id) {
      this.$apis.project.inquiry.detail({ id: this.id }).then(res => {
        this.detail = res || {}
      })
    }
  },
  methods: {
    //提交数据
    onSubmit () {
      this.$refs['ff'].validate(valid => {
        if (valid && !this.loading) {
          this.loading = true
          this.$apis.project.inquiry.submit(this.detail).then(() => {
            this.$message({ message: "数据提交成功！", type: "success" })
            this.$router.replace({
              path: 'dossier',
            })
          }).catch(e => {
            this.$message.error(e || "执行错误")
          }).finally(() => {
            this.loading = false
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.el-form {
  width: 72%;
  min-width: 720px;
  background: #fff;
  padding: 40px;
  min-height: 100%;
}
</style>